import { api } from "./typed";

/**
 * Curated shape of GET /health (#756) — the endpoint declares no response
 * model, so the generated type is `unknown` and we cast at the boundary (the
 * documented pattern, see `admin/errorLogs.ts`). Field source:
 * consultant-portal-backend `app/routers/health.py`.
 */
export interface BackendHealth {
  status: "healthy" | "degraded" | "unhealthy" | string;
  timestamp: string;
  version: string;
  version_date: string;
  service: string;
  /** Human-readable, e.g. "3d 4h 5m 6s". */
  uptime: string;
  checks?: {
    database?: string;
    memory_usage?: string;
    application?: string;
  };
}

export interface HealthCheckResult {
  health: BackendHealth;
  /** Round-trip time of the health call, in whole milliseconds. */
  latencyMs: number;
}

export const healthAPI = {
  /**
   * Ping the backend's health endpoint, measuring round-trip latency.
   * Unreachable/unhealthy (network error or 503) throws — an expected state
   * for a reachability probe, hence no error toast.
   */
  check: async (): Promise<HealthCheckResult> => {
    const startedAt = performance.now();
    const health = (await api.get("/health", {
      config: { suppressErrorToast: true },
    })) as BackendHealth;
    return { health, latencyMs: Math.round(performance.now() - startedAt) };
  },
};
